// 服务列表
<template>
  <div>
    <!-- <Header/> -->
    <logo></logo>
    <div><img :src="image" class="bg"></div>
        <div style="margin-top:1.25rem">
            <div class="select" v-for="(list,i) in lists">
            <div @click="routerLinkTo(list.name,list.id)" class="link">
                <div class="layout">
                <img class="img" src="../../assets/Investor/select.png">
                <div class="text">{{list.name}}
                </div>
            </div>
            </div>
        </div>
        </div>
        <div style="height:5.125rem;"><Tabbar></Tabbar></div>
  </div>
</template>

<script>
// import Header from '../../common/FirstHeader.vue'
import Logo from "../Index/Index_components/logo.vue"
import Tabbar from '../Index/Index_components/Tabbar.vue'
import api from '@/utils/api'
export default {
  name: 'ServicesList',
//   props: {
//     category: {
//       default: null,
//       type: String
//     }
//   },
  components: {
    Logo,
    Tabbar,
  },
  data () {
    return {
      lists: [],
      image: ''
    }
  },
  created() {
      this.getServicesList()
  },
  methods: {
    async getServicesList() {
        const { data:data } = await api.getSubCategory(this.$route.query.category)
        if (data.code ===200){
            
            this.lists = data.data

            console.log('二级分类类别列表', this.lists)
        }
        if (window.localStorage.getItem('services')){
          var image1 = JSON.parse(window.localStorage.getItem('services'))
          this.image = image1.data.data.image
        }
        
    },
    routerLinkTo (e,id) {
      this.$router.push({
        path: '/services/servicesList/category',
        query: {
          title_name: e,
          id: id
        },
      })
    },
  },
}
</script>
<style scoped>
.link {
  text-decoration: none;
}
.bg {
  width: 46.875rem;
  height: 14.75rem;
}
.tabbar {
  margin-top: 24.125rem;
}
/deep/ .select {
  width: 42.5rem;
  height: 2.125rem;
  margin-top: 3.5rem;
  text-decoration: none !important;
}
/* 蓝色小方块 */
.img {
  width: 0.875rem;
  height: 1.75rem;
  margin-left: 2.375rem;
  margin-top: auto;
  margin-bottom: auto;
}
.layout {
  display: flex;
}
/* 文字 */
.text {
  margin-left: 1rem;
  color: #333333;
  font-size: 1.875rem;
  white-space:nowrap;
}
</style>
